module.exports = __webpack_public_path__ + "static/img/homecenter.c3e4904.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/dragon/img/homecenter.png
// module id = l85n
// module chunks = 1